module.exports = __webpack_public_path__ + "img/21.0e187669.jpg";